import moment from 'moment';
import { NewProjectDefinitionFormState } from '../../state/newProjectDefinitionSlice';

type SamplingEventValidationData = {
    hasError: boolean;
    showErrorBorder: boolean;
    errorMessages: string[];
};

export const validateSamplingEvent = (formState: NewProjectDefinitionFormState, currentEventIndex: number): SamplingEventValidationData => {
    const { samplingEvents } = formState;

    const errorMessages: string[] = [];
    let hasError = false;
    let showErrorBorder = false;

    const samplingEventData = samplingEvents[currentEventIndex] || {
        name: '',
        fromDate: '',
        toDate: '',
        year: moment().year(),
    };

    // Check required fields
    if (!samplingEventData.name || !samplingEventData.fromDate || !samplingEventData.toDate) {
        hasError = true;
        if (!samplingEventData.name) errorMessages.push('Event name is required');
        if (!samplingEventData.fromDate) errorMessages.push('From date is required');
        if (!samplingEventData.toDate) errorMessages.push('To date is required');
    }

    if (samplingEventData.fromDate && samplingEventData.toDate) {
        const currentEventFromDate = moment(samplingEventData.fromDate);
        const currentEventToDate = moment(samplingEventData.toDate);

        // From date must be before or equal to To date
        if (currentEventFromDate.isAfter(currentEventToDate)) {
            hasError = true;
            showErrorBorder = true;
            errorMessages.push(`'From' date must occur before or on 'To' date`);
        }

        // Check for overlapping events in the same year
        const currentYear = samplingEventData.year || moment(samplingEventData.fromDate).year();
        const eventsInSameYear = samplingEvents
            .map((event, idx) => ({ event, idx }))
            .filter(({ event, idx }) => {
                const eventYear = event.year || (event.fromDate ? moment(event.fromDate).year() : null);
                return eventYear === currentYear && idx !== currentEventIndex && event.fromDate && event.toDate;
            });

        eventsInSameYear.forEach(({ event, idx: _idx }) => {
            const otherFromDate = moment(event.fromDate);
            const otherToDate = moment(event.toDate);

            // Check if dates overlap
            if (currentEventFromDate.isSameOrBefore(otherToDate) && currentEventToDate.isSameOrAfter(otherFromDate)) {
                hasError = true;
                showErrorBorder = true;
                errorMessages.push(`This event overlaps with another event in year ${currentYear}`);
            }
        });
    }

    return {
        hasError,
        errorMessages,
        showErrorBorder,
    };
};
